import { Component, Input, OnInit } from '@angular/core';
import { BusinessProcess } from '../../../Models/businessProcess';
import { Utils } from '../../../services/utils';
import { PaginationInstance } from 'ngx-pagination';
import { Observable } from 'rxjs';
import { ReportsServiceService } from '../../../services/reports-service';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import { tap } from 'rxjs/operators';
import { AccessControlService } from '../../../services/access-control.service';
import { BpAdministrationService } from '../../../services/bp-administration.service';
import Swal from 'sweetalert2';
import { GenericModalService } from '../../../services/generic-modal.service';
import { GenericSelectModalComponent } from '../../../generic-modal/generic-select-modal/generic-select-modal.component';
import { formatDate } from '@angular/common';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-instance-history-result',
  templateUrl: './instance-history-result.component.html',
  styleUrls: ['./instance-history-result.component.css']
})
export class InstanceHistoryResultComponent implements OnInit {

  utilsFunctions = Utils;
  config: PaginationInstance;
  data$: Observable<any[]>;
  hasData: boolean;
  stateLifeCycles: any[];
  userStatePermissions = {};
  pleaseWait = false;
  _filter: any;
  @Input() businessProcessList: BusinessProcess[];
  @Input() tableMaxHeight;
  destComponent: any = GenericSelectModalComponent;
  p = 1;
  total: number;


  constructor(
    private reportService: ReportsServiceService,
    private webClientConfig: WebClientConfigurationService,
    private accessControlService: AccessControlService,
    private bpAdministrationService: BpAdministrationService,
    private modalService: GenericModalService,
  ) {  }

  @Input()
  set filter(filter: any) {
    this._filter = filter;
    this.getPage(1);
  }

  ngOnInit() {
    this.loadLifeCycles();
    this.getEntries(1);
    this.pleaseWait = false;
  }

  getPage(page: number) {
    this.data$ = new Observable<any[]>();
    if (this._filter.businessProcessInstanceId) {
      this._filter.pageIndex = 1;
      this.data$ = this.reportService.getBusinessProcessInstanceByIdForReport(this._filter.businessProcessInstanceId)
        .pipe(
          tap( res => {
            this.total = res.total;
            this.p = 1;
            this.getPaginationConfig(page, res.total);
          }, error1 => {
            this.showErrorMessage(error1);
          }),
        );
    } else {
      this._filter.pageIndex = page;
      this.data$ = this.reportService.searchMultipleBusinessProcessInstancesHistory(this._filter)
        .pipe(
          tap( res => {
            this.total = res.total;
            this.p = page;
            this.getPaginationConfig(page, res.total);
          }, error1 => {
            this.showErrorMessage(error1);
          }),
        );
    }
    this.data$
      .subscribe( value => {
        this.hasData = value['items'].length > 0;
      });
    // document.getElementById('cardFilter').classList.add('collapsed-card');
    // document.getElementById('bodyFilter').style.display = 'none';
    // document.getElementById('footerFilter').style.display = 'none';
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.webClientConfig.getPageSizeConfig()
      .subscribe(item => {
      this.config  = {
        id: 'server',
        itemsPerPage: item,
        currentPage: _currentPage,
        totalItems: _totalItems
      };
    }, error1 => this.showErrorMessage(error1));
  }

  getBusinessProcessName(businessProcessId: number): string {
    return this.businessProcessList[this.businessProcessList
      .map( businessProcess => businessProcess.businessProcessId)
      .indexOf(businessProcessId)].name;
  }

  loadLifeCycles() {
    this.reportService.getStatesLifeCycles()
      .subscribe(
        result => {
          this.stateLifeCycles = result;
        }, error1 => {
          this.showErrorMessage(error1);
        }
      );
  }

  getLifeCycleName(lifeCycleId: number): string {
    return this.stateLifeCycles[this.stateLifeCycles
      .map( lifeCycle => lifeCycle.value)
      .indexOf(lifeCycleId)].translatedName;
  }

  getEntries(securableObjectType) {
    const coll = {};
    this.accessControlService.getAllEffectiveEntriesBySecurableObjectTypeAndUser(securableObjectType)
      .subscribe( statePermissions => {
        statePermissions.forEach( entry => {
          const objName = entry.permission.name;
          if (!coll[objName]) {
            coll[objName] = [];
          }
          coll[objName].push(entry.securableObject.securableObjectId);
        });
        this.userStatePermissions = coll;
      }, error1 => {
        this.showErrorMessage(error1);
        this.userStatePermissions = {};
      });
  }

  cancelInstanceExecution(businessProcessInstanceId) {
    this.pleaseWait = true;
    const alert = this.modalService
      .showConfirmModal('Cancelamento de instância', 'Deseja realmente efetuar esta operação?');
    alert.then( result => {
      if (result.value) {
        this.bpAdministrationService.cancelBusinessProcessInstance(businessProcessInstanceId)
          .subscribe( () => {
            this.pleaseWait = false;
            this.showSuccessMessage('Cancelamento efetuado com sucesso.');
            setTimeout(() => { this.getPage(this.p); }, 2000);
          }, error1 => {
            this.pleaseWait = false;
            this.showErrorMessage(error1);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.pleaseWait = false;
      }
    });
  }

  reexecuteInstance(businessProcessInstanceId) {
    this.pleaseWait = true;
    const alert = this.modalService
      .showConfirmModal('Reexecução de instância', 'Deseja reexecutar esta instância?');
    alert.then( result => {
      if (result.value) {
        this.bpAdministrationService.requestPreDefinedOverrideBusinessProcessInstance(businessProcessInstanceId)
          .subscribe( overrideInfo => {
            this.pleaseWait = false;
            this.showSuccessMessageWithAction(`Imposição da instância ${businessProcessInstanceId} requisitada com sucesso. </br>
                Para consultar se houve falha na execução, acesse o relatório Imposições Irregulares.`);
            setTimeout(() => { this.getPage(this.p); }, 2000);
          }, error1 => {
            this.pleaseWait = false;
            this.showErrorMessage(error1);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.pleaseWait = false;
      }
    });
  }

  viewInstance(businessProcessInstanceId) {
    this.pleaseWait = true;
    this.bpAdministrationService.getBusinessProcessViewsByInstanceId(businessProcessInstanceId)
      .subscribe( views => {
        this.pleaseWait = false;
        if (views.length > 0) {
          const result$ = this.modalService.showselectModal(
            this.destComponent,
            'Visualização da instância a partir de um layout',
            'Escolha o layout a ser exibido:',
            'OK', 'Cancelar',
            views
          );
          result$.asObservable()
            .pipe()
            .subscribe(
              viewId => {
                if (viewId !== null) {
                  // aqui será aberta a view
                  window.open(`/customInstanceView/${businessProcessInstanceId}/${viewId}`, '_blank', 'width=1800,height=850,toolbar=no,resizable=yes,alwaysRaised=true,scrollbars=yes,location=no');
                }
              }
            );
        } else {
          this.showInfoMessage('Não existem layouts cadastrados para a versão de Processo de Negócio desta instância.');
        }
      }, error1 => {
        this.showErrorMessage(error1);
        this.pleaseWait = false;
      });
  }

  showErrorMessage(text: string) {
    Swal.mixin({
      toast: true,
      position: 'top',
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #721c24;">${text}</span>`,
      showConfirmButton: true,
      confirmButtonColor: '#721c24',
      background: '#f8d7da',
      width: '50%'
    }).fire();
  }

  showInfoMessage(text: string) {
    Swal.mixin({
      toast: true,
      position: 'top',
      timer: 6000,
      icon: 'info',
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #0c5460;">${text}</span>`,
      showConfirmButton: false,
      confirmButtonColor: '#0c5460',
      background: '#d1ecf1',
      width: '50%'
    }).fire();
  }

  showSuccessMessage(text: string) {
    Swal.mixin({
      toast: true,
      position: 'top',
      timer: 3000,
      icon: 'success',
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #155724;">${text}</span>`,
      showConfirmButton: false,
      background: '#d4edda',
      width: '50%'
    }).fire();
  }

  showSuccessMessageWithAction(text: string) {
    Swal.mixin({
      toast: true,
      position: 'top',
      timer: 8000,
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #155724;">${text}</span>`,
      showConfirmButton: true,
      confirmButtonColor: '#155724',
      background: '#d4edda',
      width: '50%'
    }).fire();
  }

  generatePDF(instanceId, bpId, onlyCurrentHistory) {
      let current_date = new Date();
      let offset = current_date.getTimezoneOffset();
      let currentUrl = location.href;
      let bpName = this.getBusinessProcessName(bpId);
      let sDate = formatDate(new Date(),'ddMMyyyy',"pt-BR");
      let fileName = `${bpName}${instanceId}${sDate}.pdf`;
      this.reportService.getInstanceHistoryPdf(instanceId, bpName, currentUrl, onlyCurrentHistory,offset).subscribe(
        data => {
          switch (data.type) {
            case HttpEventType.DownloadProgress:
              console.log('Download pdf status: ' + Math.round((data.loaded / data.total) * 100) + '%');
              break;
            case HttpEventType.Response:
              const downloadedFile = new Blob([data.body], { type: data.body.type });
              const a = document.createElement('a');
              a.setAttribute('style', 'display:none;');
              document.body.appendChild(a);
              //a.download = encodeURIComponent(file.name);
              a.download = fileName;
              a.href = URL.createObjectURL(downloadedFile);
              a.target = '_blank';
              a.click();
              document.body.removeChild(a);
              break;
          }
        },
        error => {
          const errorMsg = `Erro ao realizar o download do pdf da instância: ${error}`;
          this.showErrorMessage(errorMsg);
        }
      );

  }

  onDetailsClick(businessProcessInstanceId) {
    window.open(`/instanceHistoryDetails/${businessProcessInstanceId}`, '_blank', 'width=1800,height=850,toolbar=no,resizable=yes,alwaysRaised=true,scrollbars=yes,location=no');
  }
}
